import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./CartFloatButton.scss";
import { Badge } from "react-bootstrap";
import { icons } from "@/utils/constants";
import { setShowCart } from "@/utils/constants/redux/sets";
export const CartFloatButton = ({ totalItems }) => {
    return (_jsxs("a", { onClick: () => {
            setShowCart(true);
        }, children: [_jsx(Badge, { className: "shopping-cart-button shopping-cart shopping-cart-badge", pill: true, bg: "light", text: "dark", children: totalItems }), _jsx("img", { src: icons.CoffeeBag, className: `shopping-cart-button shopping-cart`, alt: "Carrito de compras Flormorado Caf\u00E9" })] }));
};
